import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useMain } from "@/contexts/mainContext";

import relatoriosArr from "../../utils/relatorios.json";
import transparenciaArr from "../../utils/transparencia.json";

export function Transparencia() {
  const [showPreviousYears, setShowPreviousYears] = useState(false);
  const visibleReports = showPreviousYears
    ? relatoriosArr.filter((relatorio) => relatorio.year < 2025)
    : relatoriosArr.filter((relatorio) => relatorio.year >= 2025);

  const { transparencia, setTransparencia } = useMain();

  useEffect(() => {
    const response = transparenciaArr;

    setTransparencia(response);
  }, [transparenciaArr]);
  return (
    <>
      <Helmet title="Transparência" />
      <section className="flex items-center justify-center pb-8 pt-40 max-[480px]:pt-28">
        <div className="container">
          <div className="flex items-center justify-center gap-8 rounded-2xl border-[1px] border-solid border-cyan-650 py-8 max-[1024px]:flex-col max-[1024px]:border-0">
            <div className="h-[22rem] w-80 rounded-2xl border-[1px] border-white bg-cyan-650 p-4 max-[1024px]:h-auto max-[1024px]:w-full max-[1024px]:pb-8">
              <p className="font-regular mx-auto max-w-56 text-center font-roboto text-base text-white max-[1024px]:max-w-full">
                Reforçando nosso compromisso com a transparência e ética das
                atividades que desempenhamos, disponibilizamos nosso Estatuto
                Social, que define os princípios e objetivos da Cabelegria
                enquanto organização.
              </p>
              <a
                href="/assets/pdfs/Estatuto_Associacao_Cabelegria_de_Auxilio_a_Pessoa_com_Cancer.pdf"
                target="_blank"
                title="Estatuto Social"
                rel="noreferrer"
                className="relative top-4 flex justify-center"
              >
                <button className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full border-[1px] border-solid border-white bg-white px-8 font-roboto text-xl font-medium text-cyan-650 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
                  Estatuto Social
                </button>
              </a>
            </div>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-3">
              {transparencia.map((image) => {
                return (
                  <img
                    key={image.id}
                    src={`https://www.cabelegria.org/assets/transparencia/${image.imagem}`}
                    alt={image.name}
                    className="h-auto w-40 rounded-md object-cover"
                  />
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <section className="flex items-center justify-center">
        <div className="container">
          <div className="pb-20 pt-12 max-[1024px]:pt-0 max-[480px]:pb-10 lg:flex lg:flex-col">
            <Fade delay={200}>
              <h2 className="text-center font-roboto text-5xl font-bold text-purple-950 max-[1024px]:text-center max-[1024px]:text-4xl max-[480px]:text-3xl">
                Confira os balanços e relatórios de atividades
              </h2>
            </Fade>
            <div className="grid grid-cols-2 justify-items-center gap-5 pt-20 max-[670px]:grid-cols-1 max-[480px]:pt-8">
              {visibleReports.map((relatorio) => {
                return (
                  <div key={relatorio.id} className="w-3/4 max-[1024px]:w-full">
                    <Fade delay={relatorio.delay}>
                      {relatorio.url ? (
                        <Link
                          to={`/assets/pdfs/${relatorio.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block w-full"
                        >
                          <Button
                            variant="transparent"
                            size="lg"
                            className="w-full rounded-full bg-purple-950 font-roboto text-xl font-medium text-white max-[480px]:text-base"
                          >
                            {relatorio.year} - {relatorio.title}
                          </Button>
                        </Link>
                      ) : (
                        <Button
                          variant="transparent"
                          size="lg"
                          className="w-full rounded-full bg-purple-950 font-roboto text-xl font-medium text-white max-[480px]:text-base"
                        >
                          {relatorio.year} - {relatorio.title} (EM BREVE)
                        </Button>
                      )}
                    </Fade>
                  </div>
                );
              })}
            </div>
            <button
              type="button"
              onClick={() => setShowPreviousYears((previous) => !previous)}
              className="mx-auto mt-8 flex items-center gap-2 font-roboto font-medium text-purple-950 transition-opacity hover:opacity-70"
              aria-expanded={showPreviousYears}
            >
              {showPreviousYears
                ? "Voltar aos anos mais recentes"
                : "Ver anos anteriores"}
              <ChevronDown
                className={`size-5 transition-transform duration-300 ${showPreviousYears ? "rotate-180" : ""}`}
              />
            </button>
          </div>
        </div>
      </section>
      <section className="flex items-center justify-center">
        <div className="container">
          <Fade delay={200}>
            <h2 className="text-center font-roboto text-3xl font-bold text-purple-950 max-[1024px]:pb-4 max-[1024px]:text-center max-[1024px]:text-3xl max-[480px]:text-2xl">
              Confira nossas políticas de privacidade
            </h2>
          </Fade>
          <div className="flex flex-col items-center gap-5 pb-20 pt-12 max-[1024px]:pt-0">
            <div className="w-2/4 max-[1024px]:w-full">
              <Fade delay={250}>
                <Link to="/politica-de-privacidade">
                  <Button
                    variant="transparent"
                    size="lg"
                    className="w-full rounded-full bg-purple-950 font-roboto text-xl font-medium text-white max-[480px]:text-base"
                  >
                    Política de privacidade doadores
                  </Button>
                </Link>
              </Fade>
            </div>
            <div className="w-2/4 max-[1024px]:w-full">
              <Fade delay={300}>
                <Link to="/politica-de-privacidade-pacientes">
                  <Button
                    variant="transparent"
                    size="lg"
                    className="w-full rounded-full bg-purple-950 font-roboto text-xl font-medium text-white max-[480px]:text-base"
                  >
                    Política de privacidade pacientes
                  </Button>
                </Link>
              </Fade>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
